import {
    AUTH_ERROR,
    AUTH_REQUEST,
    AUTH_RESPONSE,
    AUTH_ERROR_EMPTY,
    LOGOUT_ERROR,
    LOGOUT_REQUEST,
    LOGOUT_RESPONSE,
    INCREMENT_TOKEN,
    DECREMENT_TOKEN,
    INCREMENT_TROPHY, 
} from "../../constants/actionTypes";

const initialState = {
    user: null,
    check_auth : false,
    loading: false,
    error: null
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_REQUEST:
            return { ...state, loading: true };
        case AUTH_RESPONSE:
            return { ...state, user: action.payload, check_auth: true, loading: false };
        case AUTH_ERROR:
            return { ...state, error: action.payload, loading: false };
        case LOGOUT_REQUEST:
            return { ...state, loading: true };
        case LOGOUT_RESPONSE:
            return { ...state, user: null, check_auth: false,  loading: false };
        case INCREMENT_TOKEN:
            return {
                ...state,
                user: { ...state.user, token: state.user.token + action.payload },
                loading: false
            };
        case DECREMENT_TOKEN:
            return {
                ...state,
                user: {
                    ...state.user,
                    token: state.user.token - action.payload > 0 ? state.user.token - action.payload : 0
                },
                loading: false
            };
        case INCREMENT_TROPHY:
            return {
                ...state,
                user: { ...state.user, trophy: state.user.trophy + action.payload },
                loading: false
            };
        case LOGOUT_ERROR:
            return { ...state, error: action.payload, loading: false };
        case AUTH_ERROR_EMPTY:
            return { ...state, error: null };
        default:
            return state;
    }
};

export default auth;
